import { SortChangedEvent } from 'ag-grid-community';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { useEffect, useState } from 'react';
import { ArgumentT } from 'routes/BudgetModule/config/types';

/**
 * Triggers a tracker when arguments list is sorted.
 * The column choosed to sort the list is passed in metadata, as is the sort direction.
 */
export const triggerSortArgumentTracker = (event: SortChangedEvent) => {
    const sortedColumn = event.api
        .getColumnState()
        .find((columnState) => columnState.sort);
    trackEventBudget(
        TRACKABLE_EVENTS.budget.budgetOverview.analyse_arguments.sortArgument,
        {
            sortedColumnName: sortedColumn?.colId,
            sortDirection: sortedColumn?.sort,
        },
    );
};

/**
 * Trigger a tracker event when user opens a new argument.
 */
export const triggerOpenArgumentTracker = (data: ArgumentT) =>
    trackEventBudget(
        TRACKABLE_EVENTS.budget.budgetOverview.analyse_arguments.openArgument,
        {
            argumentName: data.title,
        },
    );

/**
 * Custom hook to manage open/close arguments modal in Daf Analyse view.
 * We keep tracks of how many time a user opened a new argument and pass it as metadata of onCloseModal trackers.
 */
export const useManageCloseArgumentsModalTracker = (
    isOpen: boolean,
): { incrementOpenedArgumentsCount: () => void } => {
    const [argumentsOpenedCount, setArgumentsOpenedCount] = useState<number>(0);

    const incrementOpenedArgumentsCount = () =>
        setArgumentsOpenedCount(argumentsOpenedCount + 1);

    const triggerCloseArgumentsModalTracker = () => {
        trackEventBudget(
            TRACKABLE_EVENTS.budget.budgetOverview.analyse_arguments
                .closeArgumentModal,
            {
                openedArguments: argumentsOpenedCount,
            },
        );
    };

    useEffect(() => {
        return () => {
            if (!isOpen) {
                triggerCloseArgumentsModalTracker();
            }
        };
    });

    return { incrementOpenedArgumentsCount };
};
